"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducerPath = exports.basketApiMiddleware = exports.basketApiReducer = exports.useMakeBet = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const api_1 = require("../../api/bets/api");
const basketApi = (0, react_1.createApi)({
    reducerPath: 'basketApi',
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: '/',
    }),
    endpoints: (builder) => ({
        makeBet: builder.mutation({
            queryFn: async (betRequest) => {
                try {
                    const response = await (0, api_1.makeBet)(betRequest);
                    return { data: response.data };
                }
                catch (error) {
                    return { error };
                }
            },
        }),
    }),
});
exports.useMakeBet = basketApi.useMakeBetMutation, exports.basketApiReducer = basketApi.reducer, exports.basketApiMiddleware = basketApi.middleware, exports.reducerPath = basketApi.reducerPath;
//# sourceMappingURL=api.js.map